import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/lib/supabase';
import * as Sentry from '@sentry/react';

export function AuthCallbackPage() {
  const navigate = useNavigate();

  useEffect(() => {
    // Handle the OAuth callback
    const handleAuthCallback = async () => {
      try {
        const { data, error } = await supabase.auth.getSession();

        if (error) {
          Sentry.captureException(error, { tags: { context: 'auth_callback' } });
          navigate('/login?error=auth_failed');
          return;
        }

        // Check URL hash for recovery type (password reset flow)
        const hashParams = new URLSearchParams(window.location.hash.substring(1));
        const type = hashParams.get('type');

        if (type === 'recovery' || (data.session?.user?.aud === 'authenticated' && window.location.hash.includes('type=recovery'))) {
          // Password reset flow - redirect to reset password page
          navigate('/auth/reset-password');
        } else if (data.session?.user) {
          // Let ProtectedRoute handle onboarding redirect based on profile state.
          // AuthProvider's onAuthStateChange will fetch/create the profile.
          navigate('/dashboard');
        } else {
          navigate('/login');
        }
      } catch (err) {
        Sentry.captureException(err, { tags: { context: 'auth_callback' } });
        navigate('/login?error=auth_failed');
      }
    };

    // Also listen for auth state changes to catch recovery events
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event) => {
      if (event === 'PASSWORD_RECOVERY') {
        navigate('/auth/reset-password');
      }
    });

    handleAuthCallback();

    return () => subscription.unsubscribe();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-background-primary flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-accent-primary mx-auto mb-4" />
        <p className="text-foreground-secondary">Completing sign in...</p>
      </div>
    </div>
  );
}
